const translations = {
  "en": {
    "Confirming your payment…": "Confirming your payment…"
  },
  "zh-tw": {
    "Confirming your payment…": "正在確認您的付款…"
  }
};

export default translations;
